import React, { useId, useState } from "react";
import { splitList, uniqueCaseless } from "../../inventory/parse";

// Free-form list entry: type and press Enter or comma; Backspace on an empty
// box removes the last tag. Suggestions come from values already in use.
export default function TagInput({ id, value, onChange, suggestions = [], placeholder }) {
  const [draft, setDraft] = useState("");
  const listId = useId();

  const commit = (text) => {
    const added = splitList(text);
    if (added.length) onChange(uniqueCaseless([...value, ...added]));
    setDraft("");
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commit(draft);
    } else if (e.key === "Backspace" && !draft && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  const unused = suggestions.filter(
    (s) => !value.some((v) => v.toLowerCase() === s.toLowerCase())
  );

  return (
    <div className="tag-input">
      {value.map((tag) => (
        <span key={tag} className="tag">
          {tag}
          <button
            type="button"
            aria-label={`Remove ${tag}`}
            onClick={() => onChange(value.filter((t) => t !== tag))}
          >
            ×
          </button>
        </span>
      ))}
      <input
        id={id}
        value={draft}
        list={listId}
        placeholder={value.length ? "" : placeholder}
        onChange={(e) => {
          // Picking from the datalist fills the whole value at once
          const next = e.target.value;
          if (unused.includes(next)) commit(next);
          else setDraft(next);
        }}
        onKeyDown={onKeyDown}
        onBlur={() => draft && commit(draft)}
      />
      <datalist id={listId}>
        {unused.map((s) => (
          <option key={s} value={s} />
        ))}
      </datalist>
    </div>
  );
}
